import React from 'react';
import { IconButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { PRES } from './chrome';
import { COPY } from './presentationCopy';
import { focusVisibleSx } from './ui/focus';

const SettingsGearButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <IconButton
    onClick={onClick}
    size="small"
    title={COPY.settings}
    aria-label={COPY.settings}
    sx={{ color: PRES.textPrimary, ...focusVisibleSx }}
  >
    <SettingsIcon />
  </IconButton>
);

export default SettingsGearButton;
